import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material';
import { MaintenanceTypeApi } from '@api/maintenanceType.api';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { sentry } from 'sentry';
import { CompanyRankingService } from '../../../services/company-ranking.service';
import { DialogConfirmDeleteCriteriasGroupComponent } from '../dialog-confirm-delete-criterias-group/dialog-confirm-delete-criterias-group.component';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var DialogEditCriteriasGroupComponent = /** @class */ (function () {
    function DialogEditCriteriasGroupComponent(data, matDialog, matDialogRef, translate, fuseTranslationLoaderService, companyRanking, customMessageService, maintenanceTypeApi) {
        this.data = data;
        this.matDialog = matDialog;
        this.matDialogRef = matDialogRef;
        this.translate = translate;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.companyRanking = companyRanking;
        this.customMessageService = customMessageService;
        this.maintenanceTypeApi = maintenanceTypeApi;
        this.selectedDropdownIndex = null;
        this.defaultPoints = 100;
        this.defaultResultThreshold = 24;
        this.isOnEditDialog = false;
        this.isLoading = false;
        this.deletionShouldBeEnabled = false;
        this.criteriaRulePresence = {};
        this.alreadySelectedRules = [];
        this.isPercentageGreaterBetter = ['accepted_percentage', 'completed_percentage', 'response_on_time_percentage', 'solution_on_time_percentage'];
        this.isPercentageLowerBetter = ['refused_percentage', 'incompleted_percentage'];
        this.isMeanTime = [
            'requested_interval',
            'on_negotiation_interval',
            'pending_interval',
            'scheduled_interval',
            'in_progress_interval',
            'reported_interval',
            'response_interval',
            'solution_interval',
            'average_response_time_in_days',
            'average_close_time_in_days'
        ];
        this.typesByRange = ['response_on_time_percentage_by_range', 'solution_on_time_percentage_by_range'];
        this.criteriaRules = [];
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    DialogEditCriteriasGroupComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, criteria, _d, e_1_1;
            var e_1, _e;
            var _this = this;
            return tslib_1.__generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        this.isLoading = true;
                        this.setCriteriaRules();
                        this.deletionShouldBeEnabled = this.data && this.data.deletionShouldBeEnabled;
                        this.isOnEditDialog = !!(this.data && this.data.criteriaId);
                        if (!this.isOnEditDialog) return [3 /*break*/, 10];
                        _a = this;
                        return [4 /*yield*/, this.companyRanking.getCriteriasGroupById(this.data.criteriaId)];
                    case 1:
                        _a.criteriasGroup = _f.sent();
                        _f.label = 2;
                    case 2:
                        _f.trys.push([2, 7, 8, 9]);
                        _b = tslib_1.__values(this.criteriasGroup.criterias), _c = _b.next();
                        _f.label = 3;
                    case 3:
                        if (!!_c.done) return [3 /*break*/, 6];
                        criteria = _c.value;
                        _d = criteria;
                        return [4 /*yield*/, this.getMaintenanceTypes(criteria.value.maintenanceTypeIds)];
                    case 4:
                        _d.maintenanceTypes = _f.sent();
                        _f.label = 5;
                    case 5:
                        _c = _b.next();
                        return [3 /*break*/, 3];
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        e_1_1 = _f.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 9];
                    case 8:
                        try {
                            if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 9:
                        this.criteriasGroupForm = new FormGroup({
                            name: new FormControl(this.criteriasGroup.name || null, [Validators.required, Validators.maxLength(50)]),
                            criterias: new FormArray(this.criteriasGroup.criterias.map(function (criteria) { return _this.createCriteriaFormGroup(criteria); }) || null, [Validators.required])
                        });
                        this.updateAlreadySelectedRules();
                        this.isLoading = false;
                        return [2 /*return*/];
                    case 10:
                        this.criteriasGroupForm = new FormGroup({
                            name: new FormControl(null, [Validators.required, Validators.maxLength(50)]),
                            criterias: new FormArray([], [Validators.required])
                        });
                        this.addCriteria();
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    DialogEditCriteriasGroupComponent.prototype.getMaintenanceTypes = function (typeIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var maintenanceTypes, typeIds_1, typeIds_1_1, typeId, maintenanceType, e_2_1;
            var e_2, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        maintenanceTypes = [];
                        if (!typeIds || typeIds.length === 0) {
                            return [2 /*return*/, maintenanceTypes];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, 7, 8]);
                        typeIds_1 = tslib_1.__values(typeIds), typeIds_1_1 = typeIds_1.next();
                        _b.label = 2;
                    case 2:
                        if (!!typeIds_1_1.done) return [3 /*break*/, 5];
                        typeId = typeIds_1_1.value;
                        return [4 /*yield*/, this.maintenanceTypeApi.searchOne(typeId)];
                    case 3:
                        maintenanceType = _b.sent();
                        maintenanceTypes.push(maintenanceType);
                        _b.label = 4;
                    case 4:
                        typeIds_1_1 = typeIds_1.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_2_1 = _b.sent();
                        e_2 = { error: e_2_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (typeIds_1_1 && !typeIds_1_1.done && (_a = typeIds_1.return)) _a.call(typeIds_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/, maintenanceTypes];
                }
            });
        });
    };
    DialogEditCriteriasGroupComponent.prototype.addCriteria = function () {
        var _this = this;
        var criteriasArray = this.criteriasGroupForm.get('criterias');
        var percentRangesFormArray = new FormArray([], { validators: [this.rangeValidator.bind(this)] });
        percentRangesFormArray.push(this.addPercentRangeFormGroup());
        var formGroup = new FormGroup({
            ruleName: new FormControl(null, [Validators.required]),
            maintenanceTypes: new FormControl(null),
            value: new FormGroup({})
        });
        formGroup.controls.ruleName.valueChanges.subscribe(function (value) {
            if (_this.typesByRange.includes(value)) {
                formGroup.setControl('value', new FormGroup({
                    percentRange: percentRangesFormArray
                }));
            }
            else {
                formGroup.setControl('value', new FormGroup({
                    points: new FormControl(null, [Validators.required, Validators.max(1000)]),
                    resultThreshold: new FormControl(null, [Validators.max(1000)])
                }));
            }
            formGroup.markAsTouched();
            formGroup.updateValueAndValidity();
        });
        criteriasArray.push(formGroup);
    };
    DialogEditCriteriasGroupComponent.prototype.addRangeCriteria = function () {
        var criteriasArray = this.criteriasGroupForm.get('criterias');
        var percentRangesFormArray = new FormArray([], { validators: [this.rangeValidator.bind(this)] });
        percentRangesFormArray.push(this.addPercentRangeFormGroup());
        criteriasArray.push(new FormGroup({
            ruleName: new FormControl(null, [Validators.required]),
            maintenanceTypes: new FormControl(null),
            value: new FormGroup({
                points: new FormControl(null, [Validators.required, Validators.max(1000)]),
                resultThreshold: new FormControl(null, [Validators.max(1000)]),
                percentRange: percentRangesFormArray
            })
        }));
    };
    DialogEditCriteriasGroupComponent.prototype.rangeValidator = function (group) {
        var e_3, _a, e_4, _b;
        var rangeControls = group.controls;
        try {
            for (var rangeControls_1 = tslib_1.__values(rangeControls), rangeControls_1_1 = rangeControls_1.next(); !rangeControls_1_1.done; rangeControls_1_1 = rangeControls_1.next()) {
                var rangeControl = rangeControls_1_1.value;
                rangeControl.setErrors(null);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (rangeControls_1_1 && !rangeControls_1_1.done && (_a = rangeControls_1.return)) _a.call(rangeControls_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        var rangesSlotsInUse = this.getRangeSlotsInUse(rangeControls);
        var rangesControlWithConflict = this.getRangeControlWithConflicts(rangesSlotsInUse);
        try {
            for (var rangesControlWithConflict_1 = tslib_1.__values(rangesControlWithConflict), rangesControlWithConflict_1_1 = rangesControlWithConflict_1.next(); !rangesControlWithConflict_1_1.done; rangesControlWithConflict_1_1 = rangesControlWithConflict_1.next()) {
                var rangeWithConflict = rangesControlWithConflict_1_1.value;
                rangeWithConflict.setErrors({ rangeConflict: true });
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (rangesControlWithConflict_1_1 && !rangesControlWithConflict_1_1.done && (_b = rangesControlWithConflict_1.return)) _b.call(rangesControlWithConflict_1);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return null;
    };
    DialogEditCriteriasGroupComponent.prototype.hasError = function (control) {
        return control.status === 'INVALID' ? true : false;
    };
    DialogEditCriteriasGroupComponent.prototype.getRangeSlotsInUse = function (rangeControls) {
        var e_5, _a;
        var rangesSlotsInUse = [];
        try {
            for (var rangeControls_2 = tslib_1.__values(rangeControls), rangeControls_2_1 = rangeControls_2.next(); !rangeControls_2_1.done; rangeControls_2_1 = rangeControls_2.next()) {
                var rangeControl = rangeControls_2_1.value;
                var range = rangeControl.value;
                var slots = [];
                var start = range.start < range.end ? range.start : range.end;
                var end = range.start > range.end ? range.start : range.end;
                for (var i = start; i <= end; i++) {
                    slots.push(i);
                }
                rangesSlotsInUse.push({
                    slots: slots,
                    control: rangeControl
                });
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (rangeControls_2_1 && !rangeControls_2_1.done && (_a = rangeControls_2.return)) _a.call(rangeControls_2);
            }
            finally { if (e_5) throw e_5.error; }
        }
        return rangesSlotsInUse;
    };
    DialogEditCriteriasGroupComponent.prototype.getRangeControlWithConflicts = function (rangesSlotsInUse) {
        var e_6, _a;
        var rangesControlWithConflict = [];
        var _loop_1 = function (rangeSlots) {
            var rangeSlotsAreInUseByAnotherControl = rangesSlotsInUse.some(function (otherRangeSlots) {
                if (otherRangeSlots.control === rangeSlots.control) {
                    return false;
                }
                return rangeSlots.slots.some(function (slot) { return otherRangeSlots.slots.includes(slot); });
            });
            if (!rangeSlotsAreInUseByAnotherControl) {
                return "continue";
            }
            rangesControlWithConflict.push(rangeSlots.control);
        };
        try {
            for (var rangesSlotsInUse_1 = tslib_1.__values(rangesSlotsInUse), rangesSlotsInUse_1_1 = rangesSlotsInUse_1.next(); !rangesSlotsInUse_1_1.done; rangesSlotsInUse_1_1 = rangesSlotsInUse_1.next()) {
                var rangeSlots = rangesSlotsInUse_1_1.value;
                _loop_1(rangeSlots);
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (rangesSlotsInUse_1_1 && !rangesSlotsInUse_1_1.done && (_a = rangesSlotsInUse_1.return)) _a.call(rangesSlotsInUse_1);
            }
            finally { if (e_6) throw e_6.error; }
        }
        return rangesControlWithConflict;
    };
    DialogEditCriteriasGroupComponent.prototype.addPercentRange = function (percentRanges) {
        percentRanges.push(this.addPercentRangeFormGroup());
    };
    DialogEditCriteriasGroupComponent.prototype.addPercentRangeFormGroup = function (percentRange) {
        if (percentRange === void 0) { percentRange = null; }
        return new FormGroup({
            start: new FormControl(percentRange != null ? percentRange.start : 0, [Validators.required, Validators.min(0), Validators.max(100)]),
            end: new FormControl(percentRange != null ? percentRange.end : 0, [Validators.required, Validators.min(0), Validators.max(100)]),
            discount: new FormControl(percentRange != null ? percentRange.discount : 0, [Validators.required, Validators.min(0), Validators.max(100)]),
            points: new FormControl(percentRange != null ? percentRange.points : 0, [Validators.required, Validators.min(0), Validators.max(1000)])
        });
    };
    DialogEditCriteriasGroupComponent.prototype.removeCriteria = function (criteriaToRemove) {
        var criterias = this.criteriasGroupForm.get('criterias');
        var indexToRemove = -1;
        criterias.controls.forEach(function (criteria, index) {
            if (criteria === criteriaToRemove) {
                indexToRemove = index;
            }
        });
        if (indexToRemove !== -1) {
            criterias.removeAt(indexToRemove);
        }
        this.updateAlreadySelectedRules();
    };
    DialogEditCriteriasGroupComponent.prototype.applyCriterias = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var criteriasGroupValue, err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        criteriasGroupValue = this.toCriteriaGroupMapper(this.criteriasGroupForm.getRawValue());
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.companyRanking.updateCriteriasGroup(this.criteriasGroup.id, criteriasGroupValue)];
                    case 2:
                        _a.sent();
                        this.customMessageService.success('DIALOG_EDIT_CRITERIAS_GROUP.MESSAGES.SUCCESS_ON_UPDATE');
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        this.customMessageService.error('DIALOG_EDIT_CRITERIAS_GROUP.MESSAGES.ERROR_ON_UPDATE');
                        sentry.captureException(err_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.matDialogRef.close(true);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    DialogEditCriteriasGroupComponent.prototype.addCriteriasGroup = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var criteriasGroupValue, err_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        criteriasGroupValue = this.toCriteriaGroupMapper(this.criteriasGroupForm.getRawValue());
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.companyRanking.addCriteriasGroup(criteriasGroupValue)];
                    case 2:
                        _a.sent();
                        this.customMessageService.success('DIALOG_EDIT_CRITERIAS_GROUP.MESSAGES.SUCCESS_ON_CREATE');
                        return [3 /*break*/, 5];
                    case 3:
                        err_2 = _a.sent();
                        this.customMessageService.error('DIALOG_EDIT_CRITERIAS_GROUP.MESSAGES.ERROS_ON_CREATE');
                        sentry.captureException(err_2);
                        return [3 /*break*/, 5];
                    case 4:
                        this.matDialogRef.close(true);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    DialogEditCriteriasGroupComponent.prototype.toCriteriaGroupMapper = function (value) {
        return {
            name: value.name,
            criterias: value.criterias.map(function (criteria) {
                var maintenanceTypeIds = criteria.maintenanceTypes && criteria.maintenanceTypes.map(function (maintenanceType) { return maintenanceType.id; }) || [];
                delete criteria.maintenanceTypes;
                return {
                    ruleName: criteria.ruleName,
                    value: tslib_1.__assign({}, criteria.value, { maintenanceTypeIds: maintenanceTypeIds })
                };
            })
        };
    };
    DialogEditCriteriasGroupComponent.prototype.deleteCriteriaGroup = function () {
        var _this = this;
        var dialogConfirmDeleteCriteriasGroup = this.matDialog.open(DialogConfirmDeleteCriteriasGroupComponent, {
            panelClass: ['dialog-confirm-delete-criterias-group'],
            width: '462px',
            data: {
                id: this.criteriasGroup.id
            }
        });
        dialogConfirmDeleteCriteriasGroup.afterClosed().subscribe(function (result) {
            if (result) {
                _this.matDialogRef.close(true);
            }
        });
    };
    DialogEditCriteriasGroupComponent.prototype.deleteRangeByIndex = function (percentRanges, index) {
        var percentRangesFormArray = percentRanges;
        if (percentRangesFormArray.length > 1) {
            percentRangesFormArray.removeAt(index);
        }
    };
    DialogEditCriteriasGroupComponent.prototype.handleRuleChange = function () {
        this.updateAlreadySelectedRules();
    };
    DialogEditCriteriasGroupComponent.prototype.updateAlreadySelectedRules = function () {
        this.alreadySelectedRules = this.criteriasGroupForm.getRawValue().criterias.map(function (criteria) { return criteria.ruleName; });
    };
    DialogEditCriteriasGroupComponent.prototype.createCriteriaFormGroup = function (criteria) {
        var _this = this;
        var formGroup = new FormGroup({
            ruleName: new FormControl(criteria.ruleName, [Validators.required]),
            value: new FormGroup({}),
            maintenanceTypes: new FormControl(criteria.maintenanceTypes.map(function (maintenanceType) {
                return {
                    id: maintenanceType.id,
                    name: maintenanceType.name
                };
            }))
        });
        if (!this.typesByRange.includes(criteria.ruleName)) {
            formGroup.setControl('value', new FormGroup({
                points: new FormControl(criteria.value.points, [Validators.required, Validators.max(1000)]),
                resultThreshold: new FormControl(criteria.value.resultThreshold, [Validators.max(1000)]),
            }));
            return formGroup;
        }
        formGroup.setControl('value', new FormGroup({
            percentRange: new FormArray(criteria.value.percentRange.map(function (percentRange) { return _this.addPercentRangeFormGroup(percentRange); }) || [], { validators: [this.rangeValidator.bind(this)] })
        }));
        return formGroup;
    };
    DialogEditCriteriasGroupComponent.prototype.setCriteriaRules = function () {
        this.criteriaRules = [
            { text: this.translate.instant('DIALOG_EDIT_CRITERIAS_GROUP.CRITERIAS.ACCEPTED_PERCENTAGE'), value: 'accepted_percentage' },
            { text: this.translate.instant('DIALOG_EDIT_CRITERIAS_GROUP.CRITERIAS.REFUSED_PERCENTAGE'), value: 'refused_percentage' },
            { text: this.translate.instant('DIALOG_EDIT_CRITERIAS_GROUP.CRITERIAS.COMPLETED_PERCENTAGE'), value: 'completed_percentage' },
            { text: this.translate.instant('DIALOG_EDIT_CRITERIAS_GROUP.CRITERIAS.INCOMPLETED_PERCENTAGE'), value: 'incompleted_percentage' },
            { text: this.translate.instant('DIALOG_EDIT_CRITERIAS_GROUP.CRITERIAS.RESPONSE_ON_TIME_PERCENTAGE'), value: 'response_on_time_percentage' },
            { text: this.translate.instant('DIALOG_EDIT_CRITERIAS_GROUP.CRITERIAS.SOLUTION_ON_TIME_PERCENTAGE'), value: 'solution_on_time_percentage' },
            { text: this.translate.instant('DIALOG_EDIT_CRITERIAS_GROUP.CRITERIAS.RESPONSE_ON_TIME_PERCENTAGE_BY_RANGE'), value: 'response_on_time_percentage_by_range' },
            { text: this.translate.instant('DIALOG_EDIT_CRITERIAS_GROUP.CRITERIAS.SOLUTION_ON_TIME_PERCENTAGE_BY_RANGE'), value: 'solution_on_time_percentage_by_range' },
            { text: this.translate.instant('DIALOG_EDIT_CRITERIAS_GROUP.CRITERIAS.AVERAGE_RATING'), value: 'average_rating' },
            { text: this.translate.instant('DIALOG_EDIT_CRITERIAS_GROUP.CRITERIAS.REQUESTED_INTERVAL'), value: 'requested_interval' },
            { text: this.translate.instant('DIALOG_EDIT_CRITERIAS_GROUP.CRITERIAS.ON_NEGOTIATION_INTERVAL'), value: 'on_negotiation_interval' },
            { text: this.translate.instant('DIALOG_EDIT_CRITERIAS_GROUP.CRITERIAS.PENDING_INTERVAL'), value: 'pending_interval' },
            { text: this.translate.instant('DIALOG_EDIT_CRITERIAS_GROUP.CRITERIAS.SCHEDULED_INTERVAL'), value: 'scheduled_interval' },
            { text: this.translate.instant('DIALOG_EDIT_CRITERIAS_GROUP.CRITERIAS.IN_PROGRESS_INTERVAL'), value: 'in_progress_interval' },
            { text: this.translate.instant('DIALOG_EDIT_CRITERIAS_GROUP.CRITERIAS.REPORTED_INTERVAL'), value: 'reported_interval' },
            { text: this.translate.instant('DIALOG_EDIT_CRITERIAS_GROUP.CRITERIAS.RESPONSE_INTERVAL'), value: 'response_interval' },
            { text: this.translate.instant('DIALOG_EDIT_CRITERIAS_GROUP.CRITERIAS.SOLUTION_INTERVAL'), value: 'solution_interval' },
            { text: this.translate.instant('DIALOG_EDIT_CRITERIAS_GROUP.CRITERIAS.AVERAGE_RESPONSE_TIME_IN_DAYS'), value: 'average_response_time_in_days' },
            { text: this.translate.instant('DIALOG_EDIT_CRITERIAS_GROUP.CRITERIAS.AVERAGE_CLOSE_TIME_IN_DAYS'), value: 'average_close_time_in_days' },
        ];
    };
    return DialogEditCriteriasGroupComponent;
}());
export { DialogEditCriteriasGroupComponent };
